import { lazy, Suspense, useCallback, useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import type { IPublicMatch } from "whole-shared";

import { ws } from "../ws";
import { Loading, NotFound } from "./Components";
import { Context } from "./context";

const LazyMatch = lazy(() => import("../match"));

export const Match = () => {
  const { connected, player, updateContext } = useContext(Context);
  const setInMatch = useCallback((inMatch: boolean) => updateContext({ inMatch }), [updateContext]);
  const [details, setDetails] = useState<IPublicMatch | undefined | null>();
  const { matchId } = useParams();

  useEffect(() => {
    if(! connected || ! matchId) return;

    ws.request({ match: { matchId } }, ({ match }) => {
      if(! match) throw new Error("Missing match");

      const { details } = match;
      setDetails(details);
    });
  }, [connected, matchId]);

  if(! matchId || details === null) return <NotFound />;
  if(details === undefined) return <Loading />;

  return <Suspense fallback={<Loading />}>
    <LazyMatch details={details} player={player} setInMatch={setInMatch} />
  </Suspense>;
};
